<div class="payment-wrapper">
  <div class="summary-card">
    <h2>Order Summary</h2>
    <div class="summary-row">
      <span>Subtotal</span>
      <span>₹{{ subtotal }}</span>
    </div>
    <div class="summary-row">
      <span>Shipping</span>
      <span>₹{{ shipping }}</span>
    </div>
    <div class="summary-row">
      <span>Tax</span>
      <span>₹{{ tax }}</span>
    </div>
    <div class="summary-row total">
      <span>Total</span>
      <span>₹{{ total }}</span>
    </div>
  </div>

  <div class="qr-card">
    <p class="payment-instruction">
      Please do the payment of ₹{{ total }} to complete your order.
    </p>
    <h3>Scan & Pay</h3>
    <img src="../../assets/img/QRCode.JPG" alt="UPI QR Code" class="qr-image" />
    <p class="upi-id">UPI ID: <strong>{{ upiId }}</strong></p>
    <p class="note">Use any UPI app like GPay, PhonePe, or Paytm</p>
    <button class="confirm-btn" (click)="confirmPayment()">I Have Paid</button>
  </div>
</div>
